import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungsArtListStatus: 'idle',
    loadMeldungsArtListError: undefined as any,
    loadMeldungsArtListLastArgs: undefined as any,
    loadMeldungsArtStatus: 'idle',
    loadMeldungsArtError: undefined as any,
    saveMeldungsArtStatus: 'idle',
    saveMeldungsArtError: undefined as any,
    deleteMeldungsArtStatus: 'idle',
    deleteMeldungsArtError: undefined as any,

    meldungsArtList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungsArtList = createAsyncThunk('meldungsArtSlice/loadMeldungsArtList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungsArtSlice.loadMeldungsArtListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldungsart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungsArtListStatus } = getState().meldungsArtSlice
        return loadMeldungsArtListStatus !== 'pending'
    }
})

export const loadMeldungsArt = createAsyncThunk('meldungsArtSlice/loadMeldungsArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldungsart/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungsArtStatus } = getState().meldungsArtSlice
        return loadMeldungsArtStatus !== 'pending'
    }
})

export const saveMeldungsArt = createAsyncThunk('meldungsArtSlice/saveMeldungsArt', async ({ meldungsArt }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungsArt?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldungsart/${ meldungsArt?.HDR_ID }/`,
            prepareData(meldungsArt),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldungsart/`,
            prepareData(meldungsArt),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungsArtStatus } = getState().meldungsArtSlice
        return saveMeldungsArtStatus !== 'pending'
    }
})

export const deleteMeldungsArt = createAsyncThunk('meldungsArtSlice/deleteMeldungsArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldungsart/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungsArtStatus } = getState().meldungsArtSlice
        return deleteMeldungsArtStatus !== 'pending'
    }
})

const MeldungsArtSlice = createSlice({
    name: 'meldungsArtSlice',
    initialState,
    reducers: {
        resetloadMeldungsArtListError: (state) => {
            state.loadMeldungsArtListError = undefined
        },
        resetloadMeldungsArt: (state) => {
            state.formItem = undefined
            state.loadMeldungsArtError = undefined
        },
        resetloadMeldungsArtError: (state) => {
            state.loadMeldungsArtError = undefined
        },
        resetsaveMeldungsArt: (state) => {
            state.formItem = undefined
            state.saveMeldungsArtError = undefined
        },
        resetsaveMeldungsArtError: (state) => {
            state.saveMeldungsArtError = undefined
        },
        resetdeleteMeldungsArtError: (state) => {
            state.deleteMeldungsArtError = undefined
        },
        removeFromMeldungsArtListById: (state, action) => {
            state.meldungsArtList = state.meldungsArtList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungsArtListByIds: (state, action) => {
            state.meldungsArtList = state.meldungsArtList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungsArtList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungsArtListStatus = 'preloaded'
            state.loadMeldungsArtListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungsArtList = []
            state.loadMeldungsArtListStatus = 'idle'
            state.loadMeldungsArtListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungsArtList.pending, (state) => {
            state.loadMeldungsArtListStatus = 'pending'
            state.loadMeldungsArtListError = undefined
        })
        builder.addCase(loadMeldungsArtList.fulfilled, (state, action) => {
            state.loadMeldungsArtListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungsArtListLastArgs = action.payload.args

            {
                state.meldungsArtList = action.payload.data

            }
        })
        builder.addCase(loadMeldungsArtList.rejected, (state, action) => {
            state.loadMeldungsArtListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungsArtListError = action.error.message
            } else {
                state.loadMeldungsArtListError = action.payload
            }
        })

        builder.addCase(loadMeldungsArt.pending, (state) => {
            state.loadMeldungsArtStatus = 'pending'
            state.loadMeldungsArtError = undefined
        })
        builder.addCase(loadMeldungsArt.fulfilled, (state, action) => {
            state.loadMeldungsArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungsArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungsArtList.push(newItem) }
                else { state.meldungsArtList[i] = { ...state.meldungsArtList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungsArt.rejected, (state, action) => {
            state.loadMeldungsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungsArtError = action.error.message
            } else {
                state.loadMeldungsArtError = action.payload
            }
        })

        builder.addCase(saveMeldungsArt.pending, (state) => {
            state.saveMeldungsArtStatus = 'pending'
            state.saveMeldungsArtError = undefined
        })
        builder.addCase(saveMeldungsArt.fulfilled, (state, action) => {
            state.saveMeldungsArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungsArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungsArtList.push(newItem) }
                else { state.meldungsArtList[i] = { ...state.meldungsArtList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungsArt.rejected, (state, action) => {
            state.saveMeldungsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungsArtError = action.error.message
            } else {
                state.saveMeldungsArtError = action.payload
            }
        })

        builder.addCase(deleteMeldungsArt.pending, (state) => {
            state.deleteMeldungsArtStatus = 'pending'
            state.deleteMeldungsArtError = undefined
        })
        builder.addCase(deleteMeldungsArt.fulfilled, (state, action) => {
            state.deleteMeldungsArtStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungsArtList = state.meldungsArtList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungsArtList = state.meldungsArtList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungsArt.rejected, (state, action) => {
            state.deleteMeldungsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungsArtError = action.error.message
            } else {
                state.deleteMeldungsArtError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungsArtListError,
    resetloadMeldungsArt,
    resetloadMeldungsArtError,
    resetsaveMeldungsArt,
    resetsaveMeldungsArtError,
    resetdeleteMeldungsArtError,
    removeFromMeldungsArtListById,
    removeFromMeldungsArtListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungsArtSlice.actions
export default MeldungsArtSlice.reducer
